export const ariaLabelText = {
  drawerOpen: 'Открыть меню',
  drawerClose: 'закрыть меню',
};

export const errorText = {
  gmapKeyNotFound: 'API Key was not found',
  gmapCoordinatesNotFound: 'Coordinate was not found. Pls check data-coordinates attribute',
};

export const message = {
  missingValue: {
    checkbox: 'Это поле обязательно для заполнения.',
    radio: 'Пожалуйста, выберите значение.',
    select: 'Пожалуйста, выберите значение.',
    'select-multiple': 'Пожалуйста, выберите хотябы одно значение.',
    default: 'Пожалуйста, заполните это поле.',
  },
  patternMismatch: {
    email: 'Пожалуйста, введите существующий e-mail адрес.',
    url: 'Пожалуйста, введите ссылку.',
    number: 'Пожалуйста, введите номер',
    color: 'Please match the following format: #rrggbb',
    date: 'Please use the YYYY-MM-DD format',
    time: 'Please use the 24-hour time format. Ex. 23:00',
    month: 'Please use the YYYY-MM format',
    default: 'Please match the requested format.',
  },
  outOfRange: {
    over: 'Пожалуйста, выберите значение не более чем {max}.',
    under: 'Пожалуйста, выберите значение не менее чем {min}.',
  },
  wrongLength: {
    over: 'Пожалуйста, сократите текст до {maxLength} символов. Сейчас {length} символов.',
    under: 'Пожалуйста, удлинните текст до {minLength} символов или более. Сейчас {length} символов.',
  },
};
